import { useState } from "react";
import { Plus, Check } from "lucide-react";
import MspShell from "../../components/msp/MspShell";

const TABS = ["Pre-Trip", "During Trip", "Post-Trip"];
const PRE = [
  { id: "pp",   label: "Check passport expiration",       done: true },
  { id: "visa", label: "Apply for visa (if required)",    done: true },
  { id: "bf",   label: "Book flights",                    done: true },
  { id: "bh",   label: "Book hotels",                     done: false },
  { id: "ins",  label: "Purchase travel insurance",       done: false },
  { id: "vax",  label: "Check vaccination requirements",  done: false },
  { id: "at",   label: "Arrange airport transportation",  done: false },
  { id: "bot",  label: "Notify bank of travel",           done: false },
];

export default function MspChecklists() {
  const [t, setT] = useState("Pre-Trip");
  const [items, setItems] = useState(PRE);
  const done = items.filter((i) => i.done).length;
  const toggle = (id) => setItems((v) => v.map((i) => (i.id === id ? { ...i, done: !i.done } : i)));
  return (
    <MspShell title="Checklists" testid="msp-checklists">
      <div className="grid grid-cols-3 rounded-2xl bg-white border border-slate-200 p-1" data-testid="msp-check-tabs">
        {TABS.map((x) => (
          <button key={x} onClick={() => setT(x)} data-testid={`msp-check-tab-${x.toLowerCase().replace(/\s+/g,"-")}`}
            className={`py-2.5 rounded-xl text-sm font-700 transition ${t === x ? "bg-blue-600 text-white shadow" : "text-slate-500 hover:text-slate-800"}`}>
            {x}
          </button>
        ))}
      </div>

      <div className="bg-white rounded-3xl border border-slate-200 p-5 shadow-sm">
        <div className="font-serif font-800 text-lg text-blue-900">{t} Checklist</div>
        <div className="text-xs text-slate-500 mt-0.5">{done} / {items.length} completed</div>
        <div className="mt-3 h-2 bg-slate-100 rounded-full overflow-hidden">
          <div className="h-full bg-emerald-500 transition-all" style={{ width: `${(done / items.length) * 100}%` }} />
        </div>
      </div>

      <div className="space-y-2.5" data-testid="msp-check-list">
        {items.map((i) => (
          <button key={i.id} onClick={() => toggle(i.id)} data-testid={`msp-check-${i.id}`}
            className="w-full flex items-center gap-3 bg-white rounded-2xl border border-slate-200 p-3.5 hover:shadow-sm transition text-left">
            <span className={`w-6 h-6 rounded-md grid place-items-center border-2 ${i.done ? "bg-emerald-500 border-emerald-500 text-white" : "border-slate-300"}`}>
              {i.done && <Check className="w-4 h-4" />}
            </span>
            <span className={`flex-1 font-600 ${i.done ? "text-slate-400 line-through" : "text-slate-800"}`}>{i.label}</span>
          </button>
        ))}
      </div>

      <button data-testid="msp-check-add"
        className="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-white border-2 border-dashed border-blue-300 text-blue-700 py-3.5 font-700 hover:bg-blue-50">
        <Plus className="w-4 h-4" /> Add Item
      </button>
    </MspShell>
  );
}
